import { DependedFeature, InvestmentProductCalculationSectionStaticId } from "@pages/suppliers/constants";

export class EditProductDefaults {
  static readonly DebounceTime = 300;
  static readonly MinDateTime = new Date("1/1/2000");
  static readonly MaxDateTime = new Date("12/31/2050");
  static readonly PlaceHolder = "Please enter detail";
  static readonly AdditionalFieldTitle = "Please enter details";
  static readonly MaxNumOfChars = 100;
  static readonly InvalidDate = "Invalid Date";
  static readonly InvalidDateFormatMessage = "Invalid date format";
  static readonly MaxPercentageValue = 100;
  static readonly MaxProductCodeLength = 3;
  static readonly MaxSeriesCodeLength = 2;
  static readonly ManagerAdditionalFieldTitle = "Please enter details (optional)";
}

export enum SpecialViewingGroup {
  AllSuitabilityHubUsers = "All SuitabilityHub users",
  IMAPJudges = "IMAP Judges",
}

export class SpecialModelsSection {
  static readonly AssetAllocation = "Asset allocation";
  static readonly RiskMeasures = "Risk measures";
}
export const Limit100PercentageFeatures = [
  DependedFeature.ACTIVE_SHARE.toString(),
  DependedFeature.TARGET_GROWTH_EXPOSURE.toString(),
];

export class ReportingAndCommunicationManagerFeatures {
  static readonly ReportingAndCommunicationsSection =
    "Reporting and communications";
  static readonly Feature2 = "Report content: Portfolio changes";
  static readonly Feature3 = "Report content: Portfolio change decisions";
  static readonly Feature4 = "Report content: Performance attribution";
  static readonly Feature5 =
    "Report content: Performance attribution commentary";
  static readonly Feature6 = "Report content: Top holdings";
  static readonly Feature7 = "Report content: Market overview (retrospective)";
  static readonly Feature8 = "Report content: Market outlook (forward looking)";

  static getFeatureNames(): string[] {
    return [
      this.Feature2,
      this.Feature3,
      this.Feature4,
      this.Feature5,
      this.Feature6,
      this.Feature7,
      this.Feature8,
    ];
  }
}

export enum SpecialModelFeature {
  IMAPAward = "IMAP 2025 Managed Account Award Entry",
}

export const FeatureOnlyAdminCanUpdateData = [
  SpecialModelFeature.IMAPAward.toString(),
];

export const CalculationSectionStaticId = [
  InvestmentProductCalculationSectionStaticId.PortfoliPeriodDate,
  InvestmentProductCalculationSectionStaticId.TotalNetReturn,
  InvestmentProductCalculationSectionStaticId.NetCapitalGains,
  InvestmentProductCalculationSectionStaticId.Income,
  InvestmentProductCalculationSectionStaticId.BenchmarkReturn,
  InvestmentProductCalculationSectionStaticId.TotalNetExcessReturn,
  InvestmentProductCalculationSectionStaticId.RiskPeriodDate,
  InvestmentProductCalculationSectionStaticId.StandardDeviation,
  InvestmentProductCalculationSectionStaticId.SharpeRatio,
  InvestmentProductCalculationSectionStaticId.InformationRatio,
  InvestmentProductCalculationSectionStaticId.Beta,
  InvestmentProductCalculationSectionStaticId.DrawdownRatio,
  InvestmentProductCalculationSectionStaticId.CalmarRatio,
];
